import Vue from "vue";
import VueRouter from "vue-router";
import { CustomRoute } from "./types";
import { createGuard } from "./guard/";
import { dynimicRoutes } from "./buildDynimicRoutes";
import staticRoutes from "./buildStaticRoutes";

Vue.use(VueRouter);

let routes: Array<CustomRoute> = [];
routes = routes.concat(dynimicRoutes);
routes = routes.concat(staticRoutes);
const router = new VueRouter({
  mode: "history",
  routes,
  base: "/",
  scrollBehavior(savedPosition: any): { x: number; y: number } {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
createGuard(router);
export default router;

/**根据后台的权限模块树生成前端的路由树 */
export function buildMenuRoutes(visualRoutes: Array<any>) {
  console.log("visualRoutes:", visualRoutes);
  // const routes = generateMenuRoutes([], visualRoutes);
}
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any): any {
  return (originalPush.call(this, location) as any).catch((err: any) => err);
};
